export interface CommonTooltipData {
  name?: string;
  why?: string;
  what?: string;
  lastUpdatedTime?: string;   // or Date if you want
  firstName?: string | null;
  lastName?: string | null;
  email?: string;
  userId?: string;
  toolTipType?: ToolTipType;
  id?: string; // component id
  data?: any;
  componentType?: string;
  hideOwnerDetails?: boolean;
  
  profileUrl?: string | null;
  certification?: string;
  isFollowing?: boolean;
  contributions?: number;
  color?: { bg: string; text: string }; // optional, will be set in component
  isOwnerDetailsLoading?: boolean;
  certificateLevel?: string | null;
}

export enum ToolTipType {
  Acess_Info = 'Acess_Info',
  Personal_Widget = 'Personal_Widget',
  Shared_To_Internal = 'Shared_To_Internal',
  LEADERBOARD_INFO = 'LEADERBOARD_INFO',
  NONE = 'NONE'
}
